import React from 'react';
import PropTypes from 'prop-types';
import LineTitleGray from '../atoms/titles/LineTitleGray';

const RoomDetail = ({ room, roomType, isWDS = false }) => {
  const { name, feature, remark } = roomType;

  const {
    capacity,
    area,
    bed,
    equipment,
  } = room;

  const { smoking, noSmoking, bath, toilet } = roomType;

  const capacityText = capacity && capacity.min && capacity.max ? `${capacity.min}〜${capacity.max}名` : '';

  return (
    isWDS ? (
      <div className="planDetailTable fullWidth">
        <div className="planDetailTableBody" style={{ border: 'none'}}>
          <div className="planDetailItem">
            <div>・部屋の特徴</div>
            <div className="planDetailItemContent">
              <div>喫煙：<span>{smoking ? '○' : '×'}</span></div>
              <div>禁煙：<span>{noSmoking ? '○' : '×'}</span></div>
              <div>バス：<span>{bath ? '○' : '×'}</span></div>
              <div>トイレ：<span>{toilet ? '○' : '×'}</span></div>
            </div>
          </div>
          {feature && <div className="planDetailItem">
            <div>・部屋の説明</div>
            <div className="planDetailItemContent">
              <span dangerouslySetInnerHTML={{ __html: feature }} />
            </div>
          </div>}
        </div>
      </div>
    ) : (
    <React.Fragment>
      <LineTitleGray>部屋タイプ {name}</LineTitleGray>
      <div className="planDetailTextBody">
        <div className="table">
          <div className="planDetailTable fullWidth">
            <div className="planDetailTableHeader">部屋情報・設備</div>
            <div className="planDetailTableBody">
            <div className="planDetailTableBodyItem">
                <div className="name">詳細</div>
                <div className="content">
                  <div className="itemList">
                    {capacityText && <div className="item">
                      <span>【定員】</span>
                      <span> {capacityText}</span>
                    </div>}
                    {area && <div className="item">
                      <span>【広さ】</span>
                      <span> {area}</span>
                    </div>}
                    {bed && <div className="item">
                      <span>【ベッド】</span>
                      <span> {bed}</span>
                    </div>}
                    {feature && <div className="item">
                      <span>【部屋の特徴】</span>
                      <span dangerouslySetInnerHTML={{ __html: feature}} />
                    </div>}
                    {remark && <div className="item">
                      <span>【部屋の備考】</span>
                      <span dangerouslySetInnerHTML={{ __html: remark}} />
                    </div>}
                  </div>
                </div>
              </div>
              <div className="planDetailTableBodyItem">
                <div className="name">常備品（無料）</div>
                <div className="content">{equipment && equipment.RegularFree ? equipment.RegularFree.replace(/／/g, ',') : '-'}</div>
              </div>
              <div className="planDetailTableBodyItem">
                <div className="name">常備品（有料）</div>
                <div className="content">{equipment && equipment.RegularPaid ? equipment.RegularPaid : '-'}</div>
              </div>
              <div className="planDetailTableBodyItem">
                <div className="name">貸出品（無料）</div>
                <div className="content">{equipment && equipment.RentalFree ? equipment.RentalFree : '-'}</div>
              </div>
              <div className="planDetailTableBodyItem">
                <div className="name">貸出品（有料）</div>
                <div className="content">{equipment && equipment.RentalPaid ? equipment.RentalPaid : '-'}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
  );

};

RoomDetail.propTypes = {
  room: PropTypes.object.isRequired,
  roomType: PropTypes.object.isRequired,
};

export default RoomDetail;
